module.exports = __webpack_public_path__ + "static/media/photo-default.e3c12481.svg";